// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { MintingClaimAttribute } from '../models/MintingClaimAttribute';
import { HttpFile } from '../http/http';

export class MintingClaimUpdateRequest {
    /**
    * Maximum signed 32-bit integer.
    */
    'edition_size'?: number | null;
    'description'?: string;
    'name'?: string;
    'image_url'?: string | null;
    'external_url'?: string | null;
    'attributes'?: Array<MintingClaimAttribute>;
    'animation_url'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "edition_size",
            "baseName": "edition_size",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "image_url",
            "baseName": "image_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "external_url",
            "baseName": "external_url",
            "type": "string",
            "format": ""
        },
        {
            "name": "attributes",
            "baseName": "attributes",
            "type": "Array<MintingClaimAttribute>",
            "format": ""
        },
        {
            "name": "animation_url",
            "baseName": "animation_url",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return MintingClaimUpdateRequest.attributeTypeMap;
    }

    public constructor() {
    }
}
